exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".bookMobileStep2 .book-loader{width:100vw;height:100vh;display:flex;justify-content:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/home/book/step2/step2.mobile.scss
// module id = 792
// module chunks = 0